import React from 'react';
import styled from 'styled-components';

import { Item } from './Item';

export const ItemList = ({
  items,
  markItem,
  deleteItem,
  list,
  listIndex,
  rollouts
}) => (
  <List>
    {items &&
      items.map((item, index) => (
        <Item
          item={item}
          index={index}
          key={index.toString()}
          markItem={markItem}
          deleteItem={deleteItem}
          list={list}
          listIndex={listIndex}
          rollouts={rollouts}
        />
      ))}
  </List>
);

const List = styled.ul`
  padding: 0;
  margin: 30px 0px;
`;
